/**
 * API Configuration
 * Centralized base URL configuration for API calls
 */

// Determine if we're in development or production
const isDevelopment = process.env.NODE_ENV === 'development' || 
                      window.location.hostname === 'localhost' || 
                      window.location.hostname === '127.0.0.1';

// Base URLs
const PRODUCTION_BASE_URL = 'https://sdsapi.veeyaainnovatives.com';
const DEVELOPMENT_BASE_URL = 'https://sdsapi.veeyaainnovatives.com';
// const PRODUCTION_BASE_URL = 'http://localhost/sds-admin/public';
// const DEVELOPMENT_BASE_URL = 'http://localhost/sds-admin/public';
// // Get the appropriate base URL
const getBaseURL = () => {
    return isDevelopment ? DEVELOPMENT_BASE_URL : PRODUCTION_BASE_URL;
};

// Export the base URL
export const API_BASE_URL = getBaseURL();

// Helper function to build full API URL
export const getApiUrl = (endpoint) => {
    // Remove leading slash if present to avoid double slashes
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    return `${API_BASE_URL}/${cleanEndpoint}`;
};

export default {
    API_BASE_URL,
    getApiUrl,
    isDevelopment
};

